module.exports = __webpack_public_path__ + "account/img/178.bd5663c3.png";